import CircleExclamationPoint from './src/circle-exclamation-point-combined';
export default CircleExclamationPoint;